<div class="ion-padding">
  <div class="smtileitem-wrapper"
    [ngStyle]="{'background-image': 'url(' + safeURL(basepath+'storage/app/media'+b.image) + ')'}">
  </div>
</div>